import {useRouter} from "@tanstack/react-router";
import {PlatformUsageTracking, type UsageRouter} from "@nxt-platform/global-components";

/** Records user-ui's usage; it belongs to no tenant. */
export function UserUsageTracking() {
  const router = useRouter();
  return <PlatformUsageTracking app="user" router={router as UsageRouter}/>;
}
